const setMenuHeader = (menus) => {
    return {
        type: "SET_MENU_HEADER",
        menus
    }
}

export { setMenuHeader }